import axios from "axios";
import { warn } from "@/lib/log";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export const getJSON = async (path, params) => {
  const { data } = await http.get(path, { params });
  return data;
};

export const postJSON = async (path, body) => {
  const { data } = await http.post(path, body);
  return data;
};

export const track = (type, detail = "", path = "") => {
  try {
    navigator.sendBeacon
      ? navigator.sendBeacon(`${API}/analytics/event`, new Blob([JSON.stringify({ type, detail, path })], { type: "application/json" }))
      : http.post("/analytics/event", { type, detail, path });
  } catch (e) { warn("Analytics event not sent", e); }
};
